import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const DisplayContentStatus = ({ shareWithAll }) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid="display-content-status"
      className="display-content-status"
    >
      {shareWithAll ? t('shared') : t('notShared')}
    </div>
  );
};

DisplayContentStatus.propTypes = {
  shareWithAll: PropTypes.bool.isRequired,
};

export default DisplayContentStatus;
